import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope, FaChevronDown, FaArrowRight } from 'react-icons/fa6';
import Typewriter from './Typewriter';
import RunoutCard from './RunoutCard';

const CardRunout = () => {
  const cards = [
    { suit: "♠", rank: "A" },
    { suit: "♥", rank: "K" },
    { suit: "♦", rank: "Q" },
    { suit: "♣", rank: "J" },
    { suit: "♠", rank: "10" },
  ];
  // Slightly faster animation timings
  const slideDurationMs = 600;  // longer duration for smoother slide
  const slideSpacingMs = 120;  // tighter spacing between cards
  const flipDurationMs = 400;  // longer flip for smoothness
  const flipDelayMs = (cards.length - 1) * slideSpacingMs + slideDurationMs + 200;
  const typewriterStartDelayMs = flipDelayMs + 450; // start shortly after name reveals

  return (
    <div
      className="runout"
      aria-label="Poker runout revealing name"
      style={{ '--flip-delay': `${flipDelayMs}ms` }}
    >
      {cards.map((card, idx) => {
        const cardWidth = 160;
        const gap = 16;
        const centerIndex = 0;
        const startX = -((idx - centerIndex) * (cardWidth + gap));
        return (
          <RunoutCard
            key={idx}
            suit={card.suit}
            rank={card.rank}
            dealDelayMs={idx * slideSpacingMs}
            startX={startX}
            flipDurationMs={flipDurationMs}
            slideDurationMs={slideDurationMs}
          />
        );
      })}
      <div className="name-reveal">
        <div className="name-stack">
          <span className="name-text">Patrick Lu</span>
          <div className="subtitle-type">
            <Typewriter
              phrases={[
                'software engineer',
                'programming language enthusiast',
                'card game junkee',
              ]}
              startDelayMs={typewriterStartDelayMs}
              typeSpeedMs={85}
              deleteSpeedMs={55}
              holdMs={1100}
            />
          </div>
        </div>
      </div>
      <div className="social-icons" aria-label="Social links">
        <a href="https://github.com/P4ttyCakes" target="_blank" rel="noreferrer" aria-label="GitHub" className="social-card" style={{"--card-index": 0}}>
          <div className="social-card-inner">
            <div className="social-card-face">
              <div className="corner top-left">
                <span>J</span>
                <span className="suit black">♠</span>
              </div>
              <div className="corner bottom-right">
                <span>J</span>
                <span className="suit black">♠</span>
              </div>
              <FaGithub className="social-icon" />
            </div>
          </div>
        </a>
        <a href="https://www.linkedin.com/in/patricklu0571/" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="social-card" style={{"--card-index": 1}}>
          <div className="social-card-inner">
            <div className="social-card-face">
              <div className="corner top-left">
                <span>Q</span>
                <span className="suit red">♥</span>
              </div>
              <div className="corner bottom-right">
                <span>Q</span>
                <span className="suit red">♥</span>
              </div>
              <FaLinkedin className="social-icon" />
            </div>
          </div>
        </a>
        <a href="mailto:patlu@umich.edu" aria-label="Email" className="social-card" style={{"--card-index": 2}}>
          <div className="social-card-inner">
            <div className="social-card-face">
              <div className="corner top-left">
                <span>K</span>
                <span className="suit red">♦</span>
              </div>
              <div className="corner bottom-right">
                <span>K</span>
                <span className="suit red">♦</span>
              </div>
              <FaEnvelope className="social-icon" />
            </div>
          </div>
        </a>
        <div className="scroll-indicator" aria-hidden="true">
          <a href="#about" className="scroll-label-link">
            <span className="scroll-label">Scroll</span>
          </a>
          <a href="#about" className="scroll-arrow-link">
            <FaChevronDown className="scroll-arrow" />
          </a>
        </div>
        <div className="connect-indicator" aria-hidden="true">
          <a href="#contact" className="connect-label-link">
            <span className="connect-label">Contact Me!</span>
          </a>
          <a href="#contact" className="connect-arrow-link">
            <FaArrowRight className="connect-arrow" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default CardRunout;
